<template>
    <div class="fill flex-box nopadding col">
        <slot name="header"></slot>
        <div class="flex-box-bd fullw" style="overflow-y: auto;overflow-x: hidden">
            <slot></slot>
        </div>
        <slot name="footer"></slot>
    </div>
</template>

<script>
    export default {
        name: "mySubPage",
        props:{

        },
        data:function(){
            return{
			}
		},
        methods:{
        }
    }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/mySubPage.vue